import React from "react";
import Features from "../components/restaurants/Features";
import HowItWorks from "../components/restaurants/HowItWorks";
import Examples from "../components/restaurants/Examples";
import Pricing from "../components/restaurants/Pricing.js";
import Contact from "../components/restaurants/Contact.js";
import Menu from "../components/restaurants/Menu.js";
import Header from "../components/restaurants/Header.js";
import Footer from "../components/restaurants/Footer.js";
import PainPoints from "../components/restaurants/PainPoints.js";
import FAQ from "../components/restaurants/FAQ.js";
import { Helmet } from "react-helmet-async";
import CookiesBanner from "../components/CookiesBanner";
import { useTranslation } from "react-i18next";

const Restaurant = () => {
	const { t } = useTranslation();

	return (
		<>
			<Helmet>
				<title>{t("seo.restaurant.title")}</title>
				<meta name="description" content={t("seo.restaurant.description")} />
				<meta name="keywords" content={t("seo.restaurant.keywords")} />
				<link rel="canonical" href="https://applaby.com/restaurantes" />

				<meta property="og:title" content={t("seo.restaurant.ogTitle")} />
				<meta
					property="og:description"
					content={t("seo.restaurant.ogDescription")}
				/>
				<meta
					property="og:image"
					content="https://applaby.com/assets/restaurant/restaurant-preview.png"
				/>
				<meta property="og:url" content="https://applaby.com/restaurantes" />
				<meta property="og:type" content="website" />

				<meta name="twitter:card" content="summary_large_image" />
				<meta name="twitter:title" content={t("seo.restaurant.twitterTitle")} />
				<meta
					name="twitter:description"
					content={t("seo.restaurant.twitterDescription")}
				/>
				<meta
					name="twitter:image"
					content="https://applaby.com/assets/restaurant/restaurant-preview.png"
				/>
			</Helmet>
			{/* 1. Navegación */}
			<Menu />
			
			{/* 2. Hero con propuesta de valor clara */}
			<Header />
			
			{/* 3. Problema/Dolor - conecta con el pain point */}
			<PainPoints />
			
			{/* 4. Solución - Features simplificadas */}
			<Features />
			
			{/* 5. Pricing con comparativa de ahorro */}
			<Pricing />
			
			{/* 7. Ejemplos reales */}
			<Examples />
			
			{/* 8. Cómo funciona (3 pasos) */}
			<HowItWorks />
			
			{/* 9. FAQ - resuelve objeciones */}
			<FAQ />
			
			{/* 10. CTA final + Contacto */}
			<Contact />
			
			{/* Footer */}
			<Footer />
			<CookiesBanner />
		</>
	);
};

export default Restaurant;
